import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type UserState = {
  isAuthenticated: boolean
}

const initialState: UserState = {
  isAuthenticated: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
    logoutUser: (state) => {
      state.isAuthenticated = false
    },
  },
})

export const { setAuthenticated, logoutUser } = userSlice.actions

export default userSlice.reducer
